import { isArray } from '@mechhive/helpers';
import clsx from 'clsx';
import type { PropsWithChildren } from 'react';
import { cloneElement, isValidElement } from 'react';
import type { MenuItemProps } from './MenuItem';

export type MenuGroupProps = PropsWithChildren<{
  asGrid?: boolean;
}>;

export const MenuGroup = ( { children, asGrid = true }: MenuGroupProps ) => {
  const Items = ( isArray( children ) ? children : [ children ] ).flat();
  const Label = Items.find ( i => i?.type?.['displayName'] === 'MenuGroupLabel' );
  const MenuItems = Items.filter( i => i?.type?.['displayName'] === 'MenuItem' || i?.type?.['displayName'] === 'MenuMessage' );

  return (
    <div className={ 'flex flex-col' }>
      { ( Label && isValidElement<MenuGroupLabelProps>( Label ) ) &&
        cloneElement<MenuGroupLabelProps>( Label, Label.props )
      }
      <div className={ clsx(
        'grid gap-5 lg:gap-4',
        asGrid ? {
          'lg:grid-cols-2': MenuItems.length > 1
        } : undefined
      ) }>
        { MenuItems.map( ( element, index ) => {
          if ( !isValidElement<MenuItemProps>( element ) ) {
            return null;
          }

          return cloneElement<MenuItemProps>( element, {
            ...element.props,
            key: index
          } )
        } )}
      </div>
    </div>
  )
}
MenuGroup.displayName = 'MenuGroup';

type MenuGroupLabelProps = PropsWithChildren<{
  className?: string;
}>;

export const MenuGroupLabel = ( { className, children }: MenuGroupLabelProps ) => {
  return (
    <div className={ clsx(
      'px-3 pb-5 text-xs',
      className
    ) }>
      { children }
    </div>
  )
};
MenuGroupLabel.displayName = 'MenuGroupLabel';
